import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    emailRegistrationValues: {
        email: '',
        otpReference: '',
        scope: '',
        emailHash: '',
    },
    phoneNumberRegistrationValues: {
        phoneNumber: '',
        otpReference: '',
        scope: '',
        phoneNumberHash: '',
    },
    isContactsVerified: false,
    isEmailRegistrationOtpGenerated: false,
    isPhoneNumberRegistrationOtpGenerated: false,
    loading: false,
    error: false,
    errorMessage: '',
};

const verifyContactsSlice = createSlice({
    name: 'verifyContacts',
    initialState,
    reducers: {
        setEmailRegistrationValues: (state, action) => {
            const { email, otpReference, scope } = action.payload;
            state.emailRegistrationValues = {
                email,
                otpReference,
                scope,
                emailHash: '',
            };
        },
        setEmailHashRegistrationValues: (state, action) => {
            const { email: payloadEmail, otpReference: payloadReference, scope: payloadScope, emailHash } = action.payload;
            const { email: stateEmail, otpReference: stateReference, scope: stateScope } = state.emailRegistrationValues;
            state.emailRegistrationValues =
                stateEmail === payloadEmail && stateReference === payloadReference && stateScope === payloadScope && !!emailHash
                    ? {
                          email: payloadEmail,
                          otpReference: payloadReference,
                          scope: payloadScope,
                          emailHash,
                      }
                    : state.emailRegistrationValues;
            state.loading = false;
            state.error = false;
            state.errorMessage = '';
        },
        setPhoneNumberRegistrationValues: (state, action) => {
            const { phoneNumber, otpReference, scope } = action.payload;
            state.phoneNumberRegistrationValues = {
                phoneNumber,
                otpReference,
                scope,
                phoneNumberHash: '',
            };
        },
        setPhoneNumberHashRegistrationValues: (state, action) => {
            const {
                phoneNumber: payloadPhoneNumber,
                otpReference: payloadReference,
                scope: payloadScope,
                phoneNumberHash,
            } = action.payload;
            const { phoneNumber: statePhoneNumber, otpReference: stateReference, scope: stateScope } = state.phoneNumberRegistrationValues;
            state.phoneNumberRegistrationValues =
                statePhoneNumber === payloadPhoneNumber &&
                stateReference === payloadReference &&
                stateScope === payloadScope &&
                !!phoneNumberHash
                    ? {
                          phoneNumber: payloadPhoneNumber,
                          otpReference: payloadReference,
                          scope: payloadScope,
                          phoneNumberHash,
                      }
                    : state.phoneNumberRegistrationValues;
            state.loading = false;
            state.error = false;
            state.errorMessage = '';
        },
        setEmailRegistrationOtpGenerated: (state) => {
            state.isEmailRegistrationOtpGenerated = true;
            state.loading = false;
            state.error = false;
            state.errorMessage = '';
        },
        setPhoneNumberRegistrationOtpGenerated: (state) => {
            state.isPhoneNumberRegistrationOtpGenerated = true;
            state.loading = false;
            state.error = false;
            state.errorMessage = '';
        },
        setContactsVerified: (state) => {
            state.isContactsVerified = true;
            state.loading = false;
            state.error = false;
            state.errorMessage = '';
        },
        setLoading(state, action) {
            const { isLoading, willClearError } = action.payload;

            if (willClearError) {
                state.error = false;
                state.errorMessage = '';
            }
            state.loading = isLoading;
        },
        setError(state, action) {
            state.loading = false;
            state.error = true;
            state.errorMessage = action.payload;
        },
        clearError(state, action) {
            state.error = false;
            state.errorMessage = '';
        },
        clearVerifyContacts: (state) => initialState,
    },
});

export const verifyContactsActions = verifyContactsSlice.actions;
export default verifyContactsSlice;
